var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "" } },
    [
      _vm.withHeader ? _c("b-card-header", [_vm._t("header")], 2) : _vm._e(),
      _vm._v(" "),
      _c(
        "b-card-body",
        [
          _c("div", { staticClass: "d-flex flex-wrap" }, [
            _c("div", [
              _vm.title
                ? _c("h4", { staticClass: "card-title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.subTitle
                ? _c("h6", { staticClass: "card-subtitle" }, [
                    _vm._v(_vm._s(_vm.subTitle)),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ml-auto d-inline-flex flex-wrap" },
              [_vm._t("header-right")],
              2
            ),
          ]),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _vm.secondBody
        ? [
            _c("div", [_c("hr")]),
            _vm._v(" "),
            _c("b-card-body", [_vm._t("second-body")], 2),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.withFooter ? _c("b-card-footer", [_vm._t("footer")], 2) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }